import PatagoniaBasePublishConfirmModal from 'ContentEditorUI/components/publishing/modals/PatagoniaBasePublishConfirmModal';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped module
import { getContentTypeSlug } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
// @ts-expect-error Untyped module
import { getPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getAbsoluteUrl, getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error Untyped module
import { togglePublishModalOpen } from 'ContentEditorUI/redux/actions/appActions';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getPageSettingsFullUrl
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import PatagoniaPageAudienceAccessMsg from './PatagoniaPageAudienceAccessMsg';
import usePublishAction from '../hooks/usePublishAction';
import { getIsUngatedForUnifiedPublishButton } from 'ContentEditorUI/redux/selectors/authSelectors';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
// @ts-expect-error Untyped module
import { getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "PatagoniaPagePublishConfirmModal__Bold",
  componentId: "kvktcv-0"
})(["font-weight:bold;"]);
const PatagoniaPagePublishConfirmModal = () => {
  const publishType = useSelector(getPublishType);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const absoluteUrl = useSelector(getAbsoluteUrl);
  const constructedFullUrl = useSelector(getPageSettingsFullUrl);
  const contentType = useSelector(getContentTypeSlug);
  const name = useSelector(getContentModelName);
  const urlToDisplay = isBlogListingPage ? absoluteUrl : constructedFullUrl;
  const publishKey = publishType === PublishTypes.publish ? 'publishWithoutUrl' : 'publish';
  const publishHandler = usePublishAction();
  const dispatch = useDispatch();
  const isUngatedForUnifiedPublishButton = useSelector(getIsUngatedForUnifiedPublishButton);
  const patagoniaBasePublishConfirmModalProps = {
    afterCloseCallback: () => dispatch(togglePublishModalOpen(false)),
    headerLangKey: `publishConfirmModal.header.${publishType}`,
    primaryButtonKey: `publishConfirmModal.footer.${publishType}.primary`,
    secondaryCallback: () => dispatch(togglePublishModalOpen(false)),
    secondaryButtonKey: `publishConfirmModal.footer.cancel`,
    primaryCallback: () => publishHandler(true)
  };
  const confirmModalBody = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "m-bottom-2",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.contentInfo.name",
        options: {
          name
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "publishConfirmModal.contentInfo.url_jsx",
        options: {
          url: urlToDisplay
        },
        elements: {
          UILink,
          Bold
        }
      })]
    }), publishType !== PublishTypes.update ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `publishConfirmModal.body.${contentType}.${publishKey}`,
      options: {
        contentUrl: urlToDisplay
      }
    }) : null, /*#__PURE__*/_jsx(PatagoniaPageAudienceAccessMsg, {})]
  });
  if (isUngatedForUnifiedPublishButton) {
    // FIXME: Rename component to PublishConfirmModalBody once ungated
    return confirmModalBody;
  }
  return /*#__PURE__*/_jsx(PatagoniaBasePublishConfirmModal, Object.assign({}, patagoniaBasePublishConfirmModalProps, {
    children: confirmModalBody
  }));
};
export default PatagoniaPagePublishConfirmModal;